import { render, staticRenderFns } from "./ADTable.vue?vue&type=template&id=3f63fbeb&scoped=true&"
import script from "./ADTable.vue?vue&type=script&lang=js&"
export * from "./ADTable.vue?vue&type=script&lang=js&"
import style0 from "./ADTable.vue?vue&type=style&index=0&id=3f63fbeb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f63fbeb",
  null
  
)

export default component.exports